/* __next_internal_client_entry_do_not_use__ ModalNavigationFixed auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import * as React from "react";
import styled, { useTheme } from "styled-components";
import { IconButton } from "../../IconButton";
import { Chevron } from "../../icons/foundation/Chevron";
import { Close } from "../../icons/foundation/Close";
export var ModalNavigationFixed = function(param) {
    var onClose = param.onClose, showCloseButton = param.showCloseButton, closeButtonVariant = param.closeButtonVariant, onBack = param.onBack, onForward = param.onForward, primary = param.primary, closeIconProps = param.closeIconProps, backIconProps = param.backIconProps, forwardIconProps = param.forwardIconProps, showDivider = param.showDivider, hasImage = param.hasImage, isMobile = param.isMobile, navigationOpacity = param.navigationOpacity;
    var _theme_modals;
    var theme = useTheme();
    var modalTheme = (_theme_modals = theme.modals) === null || _theme_modals === void 0 ? void 0 : _theme_modals[primary ? "primary" : "default"];
    var _modalTheme_color;
    var iconColor = (_modalTheme_color = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.color) !== null && _modalTheme_color !== void 0 ? _modalTheme_color : Core.icon.default;
    var _modalTheme_iconProps;
    var iconProps = (_modalTheme_iconProps = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.iconProps) !== null && _modalTheme_iconProps !== void 0 ? _modalTheme_iconProps : {};
    var strictLocalize = useStrictLocalization().strictLocalize;
    var closeText = strictLocalize({
        id: "sqyFFG",
        defaultMessage: [
            {
                type: 0,
                value: "Close"
            }
        ]
    });
    var previousText = strictLocalize({
        id: "E8zXjQ",
        defaultMessage: [
            {
                type: 0,
                value: "Previous"
            }
        ]
    });
    var nextText = strictLocalize({
        id: "t+MKgo",
        defaultMessage: [
            {
                type: 0,
                value: "Next"
            }
        ]
    });
    return /*#__PURE__*/ _jsxs(HeaderWrapper, {
        $hasImage: hasImage,
        $isMobile: isMobile,
        $navigationOpacity: navigationOpacity,
        $showDivider: showDivider,
        children: [
            /*#__PURE__*/ _jsxs(NavWrapper, {
                children: [
                    onBack && /*#__PURE__*/ _jsx(IconButton, {
                        "aria-label": previousText,
                        onClick: onBack,
                        variant: hasImage && isMobile ? "secondary" : "tertiary",
                        children: /*#__PURE__*/ _jsx(Chevron, _object_spread({
                            color: iconColor,
                            direction: "left"
                        }, iconProps, backIconProps))
                    }),
                    onForward && /*#__PURE__*/ _jsx(IconButton, {
                        "aria-label": nextText,
                        onClick: onForward,
                        variant: hasImage && isMobile ? "secondary" : "tertiary",
                        children: /*#__PURE__*/ _jsx(Chevron, _object_spread({
                            color: iconColor,
                            direction: "right"
                        }, iconProps, forwardIconProps))
                    })
                ]
            }),
            showCloseButton && /*#__PURE__*/ _jsx(IconButton, {
                "aria-label": closeText,
                onClick: onClose,
                variant: closeButtonVariant !== null && closeButtonVariant !== void 0 ? closeButtonVariant : hasImage && isMobile ? "secondary" : "tertiary",
                children: /*#__PURE__*/ _jsx(Close, _object_spread({
                    color: iconColor
                }, iconProps, closeIconProps))
            })
        ]
    });
};
var HeaderWrapper = styled.div.withConfig({
    componentId: "sc-12e6a7f8-0"
})([
    "background-color:rgba( ",
    ",",
    ",",
    ",",
    " );border-bottom:1px solid rgba( ",
    ",",
    ",",
    ",",
    " );display:flex;justify-content:space-between;padding:24px 12px;position:",
    ";top:0;width:100%;z-index:100;"
], parseInt(Core.surface.inverse.substring(1, 3), 16), parseInt(Core.surface.inverse.substring(3, 5), 16), parseInt(Core.surface.inverse.substring(5, 7), 16), function(param) {
    var $navigationOpacity = param.$navigationOpacity;
    return $navigationOpacity;
}, parseInt(Core.border.muted.substring(1, 3), 16), parseInt(Core.border.muted.substring(3, 5), 16), parseInt(Core.border.muted.substring(5, 7), 16), function(param) {
    var $navigationOpacity = param.$navigationOpacity, $showDivider = param.$showDivider;
    return $showDivider ? $navigationOpacity : 0;
}, function(param) {
    var $hasImage = param.$hasImage, $isMobile = param.$isMobile;
    return $hasImage && $isMobile ? "absolute" : "sticky";
});
var NavWrapper = styled.div.withConfig({
    componentId: "sc-12e6a7f8-1"
})([
    "display:flex;gap:24px;"
]);
